import { Component } from '@angular/core';

@Component({
  selector: 'jb-list-skeleton',
  templateUrl: './list-skeleton.component.html',
})
export class ListSkeletonComponent {}
